import { useState, useEffect } from "react";
import CreamProductCard from "@/components/CreamProductCard";
import { productsByCategory } from "@/data/products";
import { goToShopifyCollection } from "@/lib/shopify";

/**
 * Crowns Section — warm taupe gallery.
 */
export const CrownsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const crowns = productsByCategory("crowns");

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && setIsVisible(true)),
      { threshold: 0.1 }
    );
    const el = document.getElementById("crowns-section");
    if (el) observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="crowns-section"
      data-testid="crowns-section"
      className="section-padding bg-[#EBE3D2] relative"
    >
      <div className="container-luxury">
        <div
          className={`text-center mb-16 md:mb-24 transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <p className="text-[11px] tracking-[0.4em] uppercase text-stone-500 mb-5">
            UNIXORN — Headwear
          </p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-6 text-stone-900">
            CROWNS
          </h2>
          <p className="text-base md:text-lg text-stone-600 tracking-wide max-w-2xl mx-auto">
            Worn at the top. Forged at the foundation.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-14 max-w-4xl mx-auto">
          {crowns.map((p, idx) => (
            <div
              key={p.id}
              className={`transition-all duration-1000 ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${idx * 150}ms` }}
            >
              <CreamProductCard product={p} size="large" />
            </div>
          ))}
        </div>

        <div className="text-center mt-20">
          <button
            onClick={() => goToShopifyCollection("crowns")}
            className="text-stone-600 hover:text-stone-900 transition-colors text-xs tracking-[0.4em] uppercase"
            data-testid="crowns-see-all"
          >
            View All Crowns →
          </button>
        </div>
      </div>
    </section>
  );
};

export default CrownsSection;
